/**
 * @param {HTMLElement} canvas - Canvas element reference
 * @param {Number} width - width to be set to the canvas
 * @param {Number} height - height to be set to the canvas
 * @description
 */
export function setCanvasSize(canvas, width, height) {
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    // Set actual size in memory (scaled to account for extra pixel density).
    const pixelRation = getScreenPixelRatio(canvas); // <--- Change to 1 on retina screens to see blurry canvas.
    canvas.width = width * pixelRation.scale;
    canvas.height = height * pixelRation.scale;
}
/**
 * @description Returns screen pixel densitiy ratio
 * @param {HtmlElement} canvas  - Canvas element
 * @param {CanvasRenderingContext2D} ctxCanvas - Canvas 2d ctx
 */
export function getScreenPixelRatio(canvas, ctxCanvas) {
    const ctx = ctxCanvas || canvas.getContext("2d");
    const dpr = window.devicePixelRatio || 1;
    const bsr = ctx.webkitBackingStorePixelRatio
      || ctx.mozBackingStorePixelRatio
      || ctx.msBackingStorePixelRatio
      || ctx.oBackingStorePixelRatio
      || ctx.backingStorePixelRatio || 1;
    return { dpr, bsr, scale: dpr };
}

/**
 *@description sets styling to the canvas
 * @param {HTMLElement} canvas Canvas Element Reference
 * @param {Map<string,string>} propMap A Map where the keys represent the CSS properties and the value is the ... value
 */
export function setCanvasStyle(canvas, propMap) {
    if (!canvas || !propMap) return;
    propMap.forEach((value, key) => {
        canvas.style[key] = value;
    });
}
/**
 * @description - Returns parent div size
 * @param {String} id - Parent ID
 */
export function getParentSize(id) {
    const parent = document.getElementById(id);
    return parent ? { width: parent.clientWidth, height: parent.clientHeight } : { width: 0, height: 0 };
}
/**
 * @description returns the canvas id from the canvas ref
 * @param {CanvasRenderingContext2D} ctx
 */
export function getInstanceIDFromCanvasInstance(ctx) {
    return ctx.canvas.id.split("canvas-")[1];
}
